export default __webpack_public_path__ + "static/media/loop-text.cbb0e09c.svg";